export { AtnEditRecordDialogComponent as Component } from './edit-record-dialog.component'
